import { message } from 'antd';
import { dafidyUserCheck, TIME_STAMP_FOR_ACTIVE_BOOKINGS, SUCCESS_STATUS } from '../utils/constant';
import { isValidArray, isValid, trimString } from '../utils/utilities';
import { EXTERNAL_API_TOKEN } from '../app.config';
import {
    SALES_SHEET_URL ,
    MASTER_AGENT_SALES_SHEET_URL,
    TRIP_SHEET_URL , 
    BOOKING_SHEET_URL , BOOKING_PREPAID_OTA_SHEET_URL,
    SMS_REPORT_SHEET_URL,
    GET_TRIPS_BY_START_DATE_URL , 
    GET_TRIPS_BY_BOOKING_DATE_URL,
    MASTER_TRIP_SHEET_URL,
    FETCH_CANCELLED_TRIP_SHEET_URL,
    PASSENGER_INFO_SHEET_URL,
    TICKET_SEARCH_URL,
    BLOCKED_SHEET_URL,
    RESCHEDULED_TICKET_REPORT_URL,
    PERFORMANCE_URL,
    TRANSACTION_SHEET_URL,
    CANCEL_TICKET_SEARCH_URL,
    ABANDONED_TRANSACTION_SHEET_URL,
    WEB_TICKET_SALES_SHEET_URL,
    GET_TICKETS_BOOKED_AFTER_TRIP_CLOSE_POINT_URL,
    GET_SETTLEMENT_REPORT_URL,
    GET_DEMAND_DATA_SHEET_URL,
    FETCH_ACTIVE_BOOKINGS_URL,
    FETCH_SERVICE_COUNT_REPORT_URL,
    FETCH_OCCUPANCY_REPORT_URL,
    FETCH_BUS_SERVICE_COLLECTION_REPORT_URL,
    GET_GST_FILING_TICKETS_URL, FETCH_TRANSACTION_COUNT_REPORT_URL,
    GET_SEAT_SHARING_REPORT_URL, FETCH_WORKFLOW_REPORT_URL,
    FETCH_PRE_PAID_TRANSACTION_COUNT_REPORT_URL,
    FETCH_OTA_TRANSACTION_REPORT_URL,
    FETCH_TRACKING_DATA_REPORT_URL,
    GET_RELEASED_SEATS_URL,
    GET_SHIFTED_PASSENGERS_URL,
    GET_NOT_BOARDED_SEATS_URL,
    FETCH_DRIVER_ATTENDANCE_REPORT_URL,
    FETCH_DRIVER_SERVICES_REPORT_URL,
    FETCH_EXPENSE_REPORT_URL,
    GET_BOARDING_DROP_STATS_URL,
    GET_UNIQUE_SCHEDULES_BY_ORIGIN_DESTINATION_URL,
    GET_STANDARD_ORIGINS_URL,
    GET_STANDARD_DESTINATIONS_URL
} from './../utils/api-url';
import { postCall, getCall } from '../utils/network.util';
import { API_SRMS_BASE_URL, API_NORTH_BASE_URL, APP_ENV, PROD_ENV, B2B_PROD_ENV, AGENT_SERVER_URL_LIST } from '../app.config';

const getTravelsAndOperatorCode=()=>{
    let operatorCode = global.operatorCode;
    let travelsId = global.travelsId;
    if(dafidyUserCheck()){
        operatorCode=null;
        travelsId=null;
    }
    return {
        operatorCode,
        travelsId
    }
}


export const fetchcancelTickets = (fromDate,toDate,isWebTicketsOnly,onSuccess=()=>{},onFailure=()=>{}) => {
    let {
        operatorCode,
        travelsId
    } = getTravelsAndOperatorCode();
    fetch(CANCEL_TICKET_SEARCH_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            fromDate,
            toDate ,
            "operatorCode":operatorCode,
            "travelsId":travelsId,
            "isWebTicketsOnly":isWebTicketsOnly         
          })
         })
        .then(response => response.json())
        .then(data => {
            onSuccess(data);
            return true;
        }).catch((reason)=> {
            message.error(`Fetching Trip sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
  }

export const fetchTripSheet = (tripId,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(TRIP_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripInfo" : {"tripId": tripId},
                              "agentId":global.agentId,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId                           
                             })
         })
        .then(response => response.json())
        .then(data => {
            onSuccess(data);
            return true;
        }).catch((reason)=> {
            message.error(`Fetching Trip sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchShiftedPassengers = (tripId,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(GET_SHIFTED_PASSENGERS_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripId": tripId})
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status === 'SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure(data.Message);
        }        
        return true;
    }).catch((reason)=> {
        message.error(`Fetching Shifted Passengers failed ${reason}`)
        onFailure();
        return false;
    }); 
}       

export const fetchReleasedSeats = (tripId,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(GET_RELEASED_SEATS_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripId": tripId})
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status === 'SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure(data.Message);
        }        
        return true;
    }).catch((reason)=> {
        message.error(`Fetching Released Seats failed ${reason}`)
        onFailure();
        return false;
    });  
}   

export const fetchCancelledTickets = (tripId,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_CANCELLED_TRIP_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripId": tripId,
                              "agentId":global.agentId,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            message.error(`Fetching Cancelled sheet failed`)
            onFailure();
            return false;
        });
}

export const fetchNotBoardedSeats = (tripId,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(GET_NOT_BOARDED_SEATS_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripId": tripId,
                              "travelsId":global.travelsId,
                              "operatorCode":global.operatorCode,
                              "agentId":global.agentId
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            message.error(`Fetching not boarded seats failed`);
            onFailure();
            return false;
        });
}

export const fetchBookingSheet = (fromDate,toDate , isBooking,onSuccess=()=>{},onFailure=()=>{}) => {
    let payload = {
        fromDate,toDate,
        isBooking,
        agentInfo:{
         "privilege":global.privilege,
         "id":global.agentId,
        },
        "operatorCode":global.operatorCode,
        "travelsId":global.travelsId
       };
    var fetchBookSheet = postCall(BOOKING_SHEET_URL, payload);
    let promiseAcions = [fetchBookSheet];
    let privilegeList = ["Prepaid-OTA", "Postpaid-OTA", "Dafidy user"];
    if ([PROD_ENV, B2B_PROD_ENV].includes(APP_ENV)&&privilegeList.includes(global.privilege)) {
        let srmsAgentId = global.prepaidOtaSrmsAgentId;
        let srmsTravelsId = global.prepaidOtaSrmsTravelsId;
        let northAgentId = global.prepaidOtaNorthAgentId;
        let northTravelsId = global.prepaidOtaNorthTravelsId;
        let srmsPayload = {
            ...payload,
            agentInfo: {
                ...payload.agentInfo,
                id: srmsAgentId
            },
            travelsId: srmsTravelsId
        };
        let northPayload = {
            ...payload,
            agentInfo: {
                ...payload.agentInfo,
                id: northAgentId
            },
            travelsId: northTravelsId
        };
        var fetchSRMSBookSheet = postCall(API_SRMS_BASE_URL+BOOKING_PREPAID_OTA_SHEET_URL, srmsPayload);
        var fetchNorthBookSheet = postCall(API_NORTH_BASE_URL+BOOKING_PREPAID_OTA_SHEET_URL, northPayload);
        promiseAcions.push(fetchSRMSBookSheet);
        promiseAcions.push(fetchNorthBookSheet);
    }
    Promise.all(promiseAcions).then((promiseData) => {
        let b2bData = promiseData[0];
        let bookedSheetData = b2bData.payload.bookedSheet;
        if (promiseAcions.length>1) {
            for (let i = 1; i < promiseAcions.length; i++) {
                let data = promiseData[i];
                let bookedSheet = data.payload.bookedSheet;
                let bookedKeys = Object.keys(bookedSheet);
                bookedKeys.map((key) => {
                    if (isValidArray(bookedSheetData[key])) {
                        bookedSheetData[key] = [...bookedSheetData[key],...bookedSheet[key]]
                    }
                    else {
                        bookedSheetData[key] = bookedSheet[key];
                    }
                });
            }
        }
        onSuccess(bookedSheetData);
    }).catch((reason) => {
        console.log("reason", reason)
        message.error(`Fetching booking sheet failed ${reason}`)
        onFailure();
    });
}


export const fetchSmsReportSheet = (fromDate,toDate , onSuccess=()=>{},onFailure=()=>{},operatorCode=null) => {
    fetch(SMS_REPORT_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
                   startDate:fromDate,endDate:toDate, 
                   messageType:"SMS",
                   "operatorCode":operatorCode,
                   "travelsId":global.travelsId             
                  })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status==="SUCCESS"&&data.Payload){
                let clientPayload=data.Payload;
                onSuccess(clientPayload);        
            }else{
                message.error(data.Message);
                onFailure();
            }
        }).catch((reason)=> {
            message.error(`Fetching failed to get sms details ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchTicketsBookedAfterStartTime = (fromDate,toDate , onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(GET_TICKETS_BOOKED_AFTER_TRIP_CLOSE_POINT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
                fromDate:fromDate,toDate:toDate, 
                "operatorCode":global.operatorCode,
                "travelsId":global.travelsId             
                })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status==="Success"){
                let clientPayload=data.tickets;
                onSuccess(clientPayload);        
            }else{
                message.error(data.Message);
                onFailure();
            }
        }).catch((reason)=> {
            message.error(`Fetching failed to get sms details ${reason}`)
            onFailure();
            return false;
        }); 
}


export const fetchTripsByBookingDate = (fromDate,toDate , onSuccess=()=>{},onFailure=()=>{}) => {
    let {
        operatorCode,
        travelsId
       } = getTravelsAndOperatorCode();
    fetch(GET_TRIPS_BY_BOOKING_DATE_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
                   fromDate,toDate, 
                   isBookingDate:false,
                   "operatorCode":operatorCode,
                   "travelsId":travelsId             
                  })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data);
            }else{
                onFailure();
                message.error(`Fetching booking sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching booking sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
}


export const fetchTripsByTravelDate = (fromDate,toDate , onSuccess=()=>{},onFailure=()=>{},partnerCode) => {
   let {
    operatorCode,
    travelsId
   } = getTravelsAndOperatorCode();
    fetch(GET_TRIPS_BY_START_DATE_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
                   fromDate,toDate, "agentInfo": {
                    "privilege":global.privilege,
                    "id":global.agentId
                   } ,
                   "operatorCode":operatorCode,
                   "travelsId":travelsId,
                   "partnerCode":partnerCode             
                  })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data);
            }else{
                onFailure();
                message.error(`Fetching schedules failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching schedules failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchSalesSheet = (tripIds,fromDate,toDate,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(SALES_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripInfo" : {"tripIds": tripIds},
                              "fromDate":fromDate,
                               "toDate":toDate,
                               "isBookingDate":isBookingDate,
                               "operatorCode":global.operatorCode,
                               "travelsId":global.travelsId
                              })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data,{
                    fromDate,toDate,isBookingDate,'agentNames':data.agentNames
                });
            }else{
                onFailure();
                message.error(`Fetching sales sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching sales sheet failed ${reason}`)
            onFailure();
            return false;
        });
}

export const fetchMasterAgentSalesSheet = (tripIds,fromDate,toDate,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(MASTER_AGENT_SALES_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripInfo" : {"tripIds": tripIds},
                              "fromDate":fromDate,
                               "toDate":toDate,
                               "isBookingDate":isBookingDate,
                               "operatorCode":global.operatorCode,
                               "travelsId":global.travelsId,
                               "agentInfo":{
                                   "id":global.agentId,
                                   "privilege":global.privilege
                               }
                              })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data,{
                    fromDate,toDate,isBookingDate,'agentNames':data.agentNames
                });
            }else{
                onFailure();
                message.error(`Fetching master agent sales sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching master agent sales sheet failed ${reason}`)
            onFailure();
            return false;
        });
}

export const fetchWebTicketSalesSheet = (tripIds,fromDate,toDate,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    let {
        operatorCode,
        travelsId
       } = getTravelsAndOperatorCode();
    fetch(WEB_TICKET_SALES_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripIds": tripIds,
                              "fromDate":fromDate,
                               "toDate":toDate,
                               "isBookingDate":isBookingDate,
                               "operatorCode":operatorCode,
                               "travelsId":travelsId                               
                              })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status==="Success"){
                onSuccess(data.webSalesSheet,{
                    fromDate,toDate,isBookingDate,'agentNames':data.agentNames
                });
            }else{
                onFailure();
                message.error(`Fetching sales sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching sales sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchMasterTripSheet = (tripId,onSuccess=()=>{},onFailure=()=>{}) =>  {
    fetch(MASTER_TRIP_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
                  "tripInfo" : {"tripId": tripId},
                  "operatorCode":global.operatorCode,
                  "travelsId":global.travelsId                 
                })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data);
            }else{
                onFailure();
                message.error(`Fetching master trip sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching master trip sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchPassengerInfoSheet = (fromDate,toDate,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(PASSENGER_INFO_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
              fromDate,toDate,isBookingDate,
              "operatorCode":global.operatorCode,
              "travelsId":global.travelsId             
            })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data.passengerInfoSheet);
            }else{
                onFailure();
                message.error(`Fetching passenger info failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching passenger info failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchTicketSearch = (
    PNR,
    Mobile_Number,
    email_id,
    Passenger_name,
    order_no,
    onSuccess=()=>{},onFailure=()=>{}
) => {
    fetch(TICKET_SEARCH_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({PNR:trimString(PNR),
            Mobile_Number:trimString(Mobile_Number),
            email_id:trimString(email_id),
            Passenger_name:trimString(Passenger_name),
            order_no:trimString(order_no),
            "operatorCode":global.operatorCode,
            "travelsId":global.travelsId     
        })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data.ticketSearchSheet);
            }else{
                onFailure();
                message.error(`Ticket search failed`)
            }
        }).catch((reason)=> {
            message.error(`Ticket search failed ${reason}`)
            onFailure();
            return false;
        }); 
  }

export const fetchTicketSearchV2 = (selectedInput, inputValue,isBooking, dateInput, onSuccess=()=>{},onFailure=()=>{}) => {
    var bodyData = {};
    bodyData[selectedInput] = trimString(inputValue);
    bodyData["isBooking"] = isBooking;
    bodyData["fromDate"] = dateInput['fromDate'];
    bodyData["toDate"] = dateInput["toDate"];
    bodyData["operatorCode"] = global.operatorCode;
    bodyData["travelsId"] = global.travelsId;
    fetch(TICKET_SEARCH_URL, {method: "POST",headers: {'Content-Type':'application/json'},body: JSON.stringify(bodyData)})
    .then(response => response.json())
    .then(data => {
        if(data){
            onSuccess(data.ticketSearchSheet);
        }else{
            onFailure();
            message.error(`Ticket search failed`)
        }
    }).catch((reason)=> {
        message.error(`Ticket search failed ${reason}`)
        onFailure();
        return false;
    });
}

export const fetchRescheduledTicketReport = (fromDate,toDate,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(RESCHEDULED_TICKET_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          fromDate,toDate,
          "operatorCode":global.operatorCode,
          "travelsId":global.travelsId
          })
         })
        .then(response => response.json())
        .then(data => {
            if(isValidArray(data)&&data.Status==="SUCCESS"){
                onSuccess(data.Payload);
            }else{
                onFailure();
                message.error(`Fetching blocked tickets reports failed!`)
            }
        }).catch((reason)=> {
            message.error(`Fetching blocked tickets reports failed${reason}`)
            onFailure();
            return false;
        });
}


  export const fetchBlockedSheet = (fromDate,toDate,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(BLOCKED_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          fromDate,toDate ,isBookingDate,
          "operatorCode":global.operatorCode,
          "travelsId":global.travelsId         
          })
         })
        .then(response => response.json())
        .then(data => {
            if(isValidArray(data)&&data.Status==="Success"){
                onSuccess(data.blockedSheet);
            }else{
                onFailure();
                message.error(`Fetching blocked tickets reports failed!`)
            }
        }).catch((reason)=> {
            message.error(`Fetching blocked tickets reports failed${reason}`)
            onFailure();
            return false;
        });
}


export const fetchPerformanceSheet = (tripIds,fromDate,toDate,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(PERFORMANCE_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"tripInfo" : {"tripIds": tripIds},
                              "fromDate":fromDate,
                               "toDate":toDate,
                               "isBookingDate":isBookingDate,
                               "operatorCode":global.operatorCode,
                               "travelsId":global.travelsId                               
                              })
         })
        .then(response => response.json())
        .then(data => {
            if(data){
                onSuccess(data);
            }else{
                onFailure();
                message.error(`Fetching blocked tickets reports failed!`)
            }
        }).catch((reason)=> {
            message.error(`Fetching blocked tickets reports failed${reason}`)
            onFailure();
            return false;
        });
}


export const fetchTransactionSheet = (fromDate,toDate,isAc,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(TRANSACTION_SHEET_URL,{
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"fromDate" : fromDate,
                              "toDate": toDate,
                              "acType":isAc,
                              "isBookingDate": isBookingDate,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId                             
                             })
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status==="Success"){
            onSuccess(data.transactionSheet);
        }else{
            onFailure();
            message.error(`Fetching transaction reports failed!`)
        }
    }).catch((reason)=> {
        message.error(`Fetching transaction reports failed${reason}`)
        onFailure();
        return false;
    });
}


export const fetchAbandonedTransactionSheet = (selectedDate , onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(ABANDONED_TRANSACTION_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
                   date:selectedDate, 
                   "operatorCode":global.operatorCode,
                   "travelsId":global.travelsId             
                  })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status==='SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure();
                message.error(`Fetching abandoned sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching abandoned sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchSettlementSheet = ( fromDate , toDate , bookingType , partnerCode,scheduleIds,onSuccess=()=>{},onFailure=()=>{}) => {
    fetch(GET_SETTLEMENT_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            fromDate:fromDate, 
            toDate:toDate,bookingType,
            "operatorCode":global.operatorCode,
            "travelsId":global.travelsId,
            "partnerCode":partnerCode,
            "scheduleIds":scheduleIds             
            })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status==='SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure();
                message.error(`Fetching settlement sheet failed`)
            }
        }).catch((reason)=> {
            message.error(`Fetching settlement sheet failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const fetchDemandDataSheet = (fromDate, toDate, onSuccess=()=>{}, onFailure=()=>{}) => {
    fetch(GET_DEMAND_DATA_SHEET_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            fromDate:fromDate,
            toDate:toDate,
        })
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status==='SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure();
            message.error(`Fetching demand data sheet failed`)
        }
    }).catch((reason)=> {
        message.error(`Fetching demand data sheet failed ${reason}`)
        onFailure();
        return false;
    });
}


export const getActiveBookings = (onSuccess=()=>{},onFailure=()=>{}) => {
    let {
        operatorCode,
        travelsId
    } = getTravelsAndOperatorCode();
    return fetch(FETCH_ACTIVE_BOOKINGS_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json', 'apitoken': EXTERNAL_API_TOKEN},
        body: JSON.stringify({"minutes": TIME_STAMP_FOR_ACTIVE_BOOKINGS,
                              "agentId":global.agentId,
                              "operatorCode":operatorCode,
                              "travelsId":travelsId
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            console.error(`Failed`, reason)
            message.error(`Fetching Active Bookings`)
            onFailure();
            return false;
        }); 
}


export const getServiceCount = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_SERVICE_COUNT_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({startDate,endDate,
                              "agentId":global.agentId,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId                           
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            console.error(`Failed`, reason)
            message.error(`Fetching service count bookings failed`)
            onFailure();
            return false;
        }); 
}

export const getOccupancyReportAction = (fromDate,toDate,tripStatus,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_OCCUPANCY_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({fromDate,toDate,tripStatus,
                              "agentId":global.agentId,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            console.error(`Failed`, reason)
            message.error(`Fetching occupancy report failed`)
            onFailure();
            return false;
        });
}

export const getBusServiceCollectionReportAction = (fromDate,toDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_BUS_SERVICE_COLLECTION_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({fromDate,toDate,
                              "agentId":global.agentId,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            console.error(`Failed`, reason)
            message.error(`Fetching bus service collection report failed`)
            onFailure();
            return false;
        });
}

export const fetchGstFilingTickets = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(GET_GST_FILING_TICKETS_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({"startDate" : startDate,
                              "endDate":endDate,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId                           
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            message.error(`Fetching gst filing tickets failed ${reason}`)
            onFailure();
            return false;
        }); 
}

export const getSeatSharingReport = (fromDate,toDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(GET_SEAT_SHARING_REPORT_URL,{
        method: "POST",
        headers: {'Content-Type':'application/json'},
         body: JSON.stringify({"fromDate" : fromDate,
                              "toDate":toDate,
                              "operatorCode":global.operatorCode,
                              "travelsId":global.travelsId                           
                             })
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            message.error(`Fetching seat sharing failed ${reason}`);
            onFailure("Failed to get seat sharing report");
            return false;
        }); 
}

export const getWorkFlowAction = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    let promiseActions = [];
    let urlList = AGENT_SERVER_URL_LIST;
    if (APP_ENV == B2B_PROD_ENV) {
        urlList = urlList.filter(url => url !== API_SRMS_BASE_URL);
    }
    urlList.forEach(url => {
        var fetch = postCall(url + FETCH_WORKFLOW_REPORT_URL, { startDate, endDate });
        promiseActions.push(fetch);
    });
    Promise.all(promiseActions).then((promiseData) => {
        let finalData = [];
        promiseData.forEach((data) => {
            if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS") {
                finalData.push(...data.payload.Payload);
            }
        });
        // Raw rows: maven fields carry only maven; other partners stay in
        // partnerActivity so the billing report can show them as their own
        // columns. Consumers needing whole-program (QwikBus) totals fold via
        // ota-partner.util (SKU pushes, invoice export, settlement lines).
        onSuccess(finalData);
    }).catch((reason)=> {
        console.error(`Failed`, reason)
        message.error(`Fetching work flow data failed`)
        onFailure("Failed to get work flow data");
        return false;
    });
}

export const getTransactionCountAction = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_TRANSACTION_COUNT_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({startDate,endDate})
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            console.error(`Failed`, reason)
            message.error(`Fetching Transaction count failed`)
            onFailure();
            return false;
        });
}

export const getPrePaidTrasactionsSummary = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    let promiseActions = [];
    // Non-maven OTA partner agents fetch only their own transactions via the
    // generic report; maven keeps the legacy route until the registry is
    // proven in production.
    const partnerConfig = global.otaPartnerConfig;
    const usePartnerRoute = isValid(partnerConfig) && partnerConfig.code != 'maven';
    AGENT_SERVER_URL_LIST.forEach(url => {
        var fetch = usePartnerRoute
            ? postCall(url+FETCH_OTA_TRANSACTION_REPORT_URL, {startDate, endDate, agentName: partnerConfig.code})
            : postCall(url+FETCH_PRE_PAID_TRANSACTION_COUNT_REPORT_URL, {startDate, endDate});
        promiseActions.push(fetch);
    });
    Promise.all(promiseActions).then((promiseData) => {
        let finalData = {};
        promiseData.forEach((data, index) => {
            if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS") {
                if(index == 0) {
                    finalData['transactions'] = data.payload.Payload.transactions;
                }else {
                    finalData['transactions'] = [...finalData['transactions'],...data.payload.Payload.transactions];
                }
            }
        });
        onSuccess(finalData);
    })
    .catch((reason)=> {
        console.log("reason", reason)
        onFailure("Failed to get transaction summary.");
        message.error(`Fetching Transaction count failed`)
    })
}

export const getTrackingReportDataAction = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_TRACKING_DATA_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({startDate,endDate})
         })
        .then(response => response.json())
        .then(data => {
            if(data.Status === 'SUCCESS'){
                onSuccess(data.Payload);
            }else{
                onFailure(data.Message);
            }
            return true;
        }).catch((reason)=> {
            console.error(`Failed`, reason)
            message.error(`Fetching Tracking report failed`)
            onFailure();
            return false;
        });
}

export const getDriverAttendanceReportAction = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_DRIVER_ATTENDANCE_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            startDate,
            endDate,
            "operatorCode":global.operatorCode,
            "travelsId":global.travelsId
        })
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status === 'SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure(data.Message);
        }
        return true;
    }).catch((reason)=> {
        console.error(`Failed`, reason)
        message.error(`Fetching Driver Attendance report failed`)
        onFailure();
        return false;
    });
}

export const getDriverServicesReportAction = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_DRIVER_SERVICES_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            startDate,
            endDate,
            "operatorCode":global.operatorCode,
            "travelsId":global.travelsId
        })
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status === 'SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure(data.Message);
        }
        return true;
    }).catch((reason)=> {
        console.error(`Failed`, reason)
        message.error(`Fetching Driver Services report failed`)
        onFailure();
        return false;
    });
}

export const fetchExpenseReport = (tripIds,onSuccess=()=>{},onFailure=()=>{}) => {
    return fetch(FETCH_EXPENSE_REPORT_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({tripIds})
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status === 'SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure(data.Message);
        }
        return true;
    }).catch((reason)=> {
        console.error(`Failed`, reason)
        message.error(`Fetching Expense report failed`)
        onFailure();
        return false;
    });
}

// Stop Analysis Report Actions
export const fetchUniqueSchedulesByOriginDestination = (origin, destination, startDate, endDate, onSuccess=()=>{}, onFailure=()=>{}) => {
    return fetch(GET_UNIQUE_SCHEDULES_BY_ORIGIN_DESTINATION_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            origin,
            destination,
            startDate,
            endDate,
            travelsId: global.travelsId
        })
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status === 'SUCCESS'){
            onSuccess(data.Payload);
        }else{
            onFailure(data.Message || 'Failed to fetch schedules');
        }
        return true;
    }).catch((reason)=> {
        console.error(`Failed`, reason)
        message.error(`Fetching schedules failed`)
        onFailure();
        return false;
    });
}

export const fetchBoardingDropStats = (scheduleId, startDate, endDate, onSuccess=()=>{}, onFailure=()=>{}) => {
    return fetch(GET_BOARDING_DROP_STATS_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            scheduleId,
            startDate,
            endDate
        })
    })
    .then(response => response.json())
    .then(data => {
        if(data && data.cities){
            onSuccess(data);
        }else if(data && data.error){
            onFailure(data.error);
        }else{
            onFailure('Failed to fetch boarding drop stats');
        }
        return true;
    }).catch((reason)=> {
        console.error(`Failed`, reason)
        message.error(`Fetching stop analysis data failed`)
        onFailure();
        return false;
    });
}

export const fetchStandardOrigins = (onSuccess = () => {}, onFailure = () => {}) => {
    return getCall(GET_STANDARD_ORIGINS_URL, { operatorCode: global.operatorCode })
        .then((apiResult) => {
            if (apiResult.status !== SUCCESS_STATUS) {
                onFailure();
                return;
            }
            const body = apiResult.payload;
            if (body && body.Status === SUCCESS_STATUS && isValidArray(body.Payload)) {
                onSuccess(body.Payload);
            } else if (body && body.Status === 'FAILURE') {
                message.error(body.Message || 'Failed to load origins');
                onFailure();
            } else {
                onFailure();
            }
        })
        .catch((reason) => {
            console.error('fetchStandardOrigins', reason);
            message.error('Failed to load origins');
            onFailure();
        });
};

export const fetchStandardDestinations = (origin, onSuccess = () => {}, onFailure = () => {}) => {
    if (!isValid(origin) || String(origin).trim() === '') {
        onFailure();
        return Promise.resolve();
    }
    const url = `${GET_STANDARD_DESTINATIONS_URL}?origin=${encodeURIComponent(origin)}`;
    return getCall(url, { operatorCode: global.operatorCode })
        .then((apiResult) => {
            if (apiResult.status !== SUCCESS_STATUS) {
                onFailure();
                return;
            }
            const body = apiResult.payload;
            if (body && body.Status === SUCCESS_STATUS && isValidArray(body.Payload)) {
                onSuccess(body.Payload);
            } else if (body && body.Status === 'FAILURE') {
                message.error(body.Message || 'Failed to load destinations');
                onFailure();
            } else {
                onFailure();
            }
        })
        .catch((reason) => {
            console.error('fetchStandardDestinations', reason);
            message.error('Failed to load destinations');
            onFailure();
        });
};